import {
  NotificationArea,
  NotificationSubArea,
  NotificationTopic,
} from '~/services/Http';

export const redirectByTopicRules: Array<
  [NotificationTopic, NotificationArea, NotificationSubArea]
> = [
  [
    NotificationTopic.ABSENCE_LONG_START,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_LONG_END,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ALLOWANCE_PROPOSED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.ALLOWANCE_REJECTED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.BANK_ACCOUNT_UPDATED,
    NotificationArea.REWARDING,
    NotificationSubArea.INCENTIVES,
  ],
  [
    NotificationTopic.BENEFIT_PROPOSED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.BENEFIT_REJECTED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.CANDIDATE_ADVANCED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.CANDIDATE_CREATED,
    NotificationArea.RECRUITING,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.COLLAB_TASK_COMMENT_CREATED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.COLLAB_TASK_COMMENT_DELETED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.COLLAB_TASK_COMMENT_UPDATED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.DOCUMENT_EXPIRATION,
    NotificationArea.PEOPLE,
    NotificationSubArea.DOCUMENTS,
  ],
  [
    NotificationTopic.DOCUMENT_APPROVED,
    NotificationArea.PEOPLE,
    NotificationSubArea.DOCUMENTS,
  ],
  [
    NotificationTopic.DOCUMENT_REJECTED,
    NotificationArea.PEOPLE,
    NotificationSubArea.DOCUMENTS,
  ],
  [
    NotificationTopic.EARLY_INVOLVEMENT_NEXT_ACTIVITY,
    NotificationArea.PERFORMANCE,
    NotificationSubArea.PROCESS_EVAL,
  ],
  [
    NotificationTopic.PERF_APPRAISAL_TEMPLATE_EXPIRY,
    NotificationArea.PERFORMANCE,
    NotificationSubArea.APPRAISAL_EVALUTION,
  ],
  [
    NotificationTopic.PERF_PROCESS_TEMPLATE_EXPIRY,
    NotificationArea.EARLY_INVOLVEMENT,
    NotificationSubArea.PROCESS_EVAL,
  ],
  [
    NotificationTopic.EMPLOYEE_BIRTHDAY,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_CONTACT_UPDATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.CONTACT,
  ],
  [
    NotificationTopic.EMPLOYEE_DATA_EXPIRED,
    NotificationArea.PEOPLE,
    NotificationSubArea.FORMER_EMPLOYEES,
  ],
  [
    NotificationTopic.EMPLOYEE_EMPLOYMENT_END,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_EMPLOYMENT_PLANNED_END,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_EMPLOYMENT_START,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_POSITION_UPDATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_TRIAL_END,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYEE_WORKANNIVERSARY,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYMENT_DETAILS_UPDATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYMENT_DETAILS_APPROVED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYMENT_DETAILS_PROPOSED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYMENT_UPDATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.EMPLOYMENT_WORKING_HOURS_UPDATED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.EMPLOYMENT_WORKING_HOURS_UPDATED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.EQUIPMENT_CREATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.EQUIPMENT,
  ],
  [
    NotificationTopic.EQUIPMENT_DELETED,
    NotificationArea.PEOPLE,
    NotificationSubArea.EQUIPMENT,
  ],
  [
    NotificationTopic.EQUIPMENT_EDITED,
    NotificationArea.PEOPLE,
    NotificationSubArea.EQUIPMENT,
  ],
  [
    NotificationTopic.EQUIPMENT_EXPIRATION,
    NotificationArea.PEOPLE,
    NotificationSubArea.EQUIPMENT,
  ],
  [
    NotificationTopic.INCENTIVE_SHORT_PROPOSED,
    NotificationArea.REWARDING,
    NotificationSubArea.INCENTIVES,
  ],
  [
    NotificationTopic.INCENTIVE_SHORT_REJECTED,
    NotificationArea.REWARDING,
    NotificationSubArea.INCENTIVES,
  ],
  [
    NotificationTopic.JOB_APP_RECEIVED,
    NotificationArea.OPENJOB,
    NotificationSubArea.OPEN_POSITIONS_NEW,
  ],
  [
    NotificationTopic.JOB_OPENING_APPROVED,
    NotificationArea.RECRUITING,
    NotificationSubArea.NEW_POSITIONS,
  ],
  [
    NotificationTopic.JOB_OPENING_PROPOSED,
    NotificationArea.RECRUITING,
    NotificationSubArea.NEW_POSITIONS,
  ],
  [
    NotificationTopic.JOB_OPENING_REJECTED,
    NotificationArea.RECRUITING,
    NotificationSubArea.ARCHIVED_POSITIONS,
  ],
  [
    NotificationTopic.MANAGER_EMPLOYMENT_END,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.PROVISIONAL_EMP_ADVANCED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.PROVISIONAL_EMP_CREATED,
    NotificationArea.RECRUITING,
    NotificationSubArea.PROVISIONAL_EMPLOYEES,
  ],
  [
    NotificationTopic.RECRUITING_DATA_EXPIRED,
    NotificationArea.RECRUITING,
    NotificationSubArea.ARCHIVED_CANDIDATES,
  ],
  [
    NotificationTopic.RECRUITING_DATA_EXPIRING,
    NotificationArea.RECRUITING,
    NotificationSubArea.ARCHIVED_CANDIDATES,
  ],
  [
    NotificationTopic.SALARY_CHANGED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.SALARY_PROPOSED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.SALARY_REJECTED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.SICK_LEAVES_LIMIT_BREACH,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.SICK_LEAVES_DAYS_LIMIT_BREACH,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.SYS_PERFORMANCE_GOAL,
    NotificationArea.NONE,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.TRAINING_EXPIRATION,
    NotificationArea.DEVELOPMENT,
    NotificationSubArea.EDUCATION,
  ],
  [
    NotificationTopic.UNIT_MANAGER_CHANGED,
    NotificationArea.PEOPLE,
    NotificationSubArea.BASIC_DATA,
  ],
  [
    NotificationTopic.BILLABLE_HOURS_APPROVED,
    NotificationArea.REWARDING,
    NotificationSubArea.BILLABLE_HOURS,
  ],
  [
    NotificationTopic.BILLABLE_HOURS_PROPOSED,
    NotificationArea.REWARDING,
    NotificationSubArea.BILLABLE_HOURS,
  ],
  [
    NotificationTopic.BILLABLE_HOURS_REJECTED,
    NotificationArea.REWARDING,
    NotificationSubArea.BILLABLE_HOURS,
  ],
  [
    NotificationTopic.COLLAB_TASK_CREATED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.COLLAB_TASK_UPDATED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.COLLAB_TASK_COMPLETED,
    NotificationArea.COLLABORATION,
    NotificationSubArea.NONE,
  ],
  [
    NotificationTopic.PERF_STATUS_DISCUSSION_EXPIRED,
    NotificationArea.PERFORMANCE,
    NotificationSubArea.STATUS_DISCUSSION,
  ],
  [
    NotificationTopic.ABSENCE_SHORT_CREATE,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_SHORT_UPDATE,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_SHORT_DELETED,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_LONG_CREATE,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_LONG_UPDATE,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ABSENCE_LONG_DELETED,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.PERF_GOAL_UPDATE,
    NotificationArea.PERFORMANCE,
    NotificationSubArea.GOAL_SETTING,
  ],
  [
    NotificationTopic.DEV_COMPETENCY_UPDATE,
    NotificationArea.DEVELOPMENT,
    NotificationSubArea.COMPETENCIES,
  ],
  [
    NotificationTopic.DEV_PLAN_UPDATE,
    NotificationArea.DEVELOPMENT,
    NotificationSubArea.DEVELOPMENT_PLAN,
  ],
  [
    NotificationTopic.SICK_DAYS_LIMIT_BREACH,
    NotificationArea.PEOPLE,
    NotificationSubArea.ABSENCES,
  ],
  [
    NotificationTopic.ALLOWANCE_APPROVED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.BENEFIT_APPROVED,
    NotificationArea.REWARDING,
    NotificationSubArea.BENEFITS,
  ],
  [
    NotificationTopic.INCENTIVE_SHORT_APPROVED,
    NotificationArea.REWARDING,
    NotificationSubArea.INCENTIVES,
  ],
  [
    NotificationTopic.SALARY_APPROVED,
    NotificationArea.REWARDING,
    NotificationSubArea.GENERAL,
  ],
  [
    NotificationTopic.WORKLIST_CREATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.COLLABORATION,
  ],
  [
    NotificationTopic.WORKLIST_COMPLETED,
    NotificationArea.PEOPLE,
    NotificationSubArea.COLLABORATION,
  ],
  [
    NotificationTopic.WORKLIST_TASK_CREATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.COLLABORATION,
  ],
  [
    NotificationTopic.WORKLIST_TASK_UPDATED,
    NotificationArea.PEOPLE,
    NotificationSubArea.COLLABORATION,
  ],
  [
    NotificationTopic.WORKLIST_TASK_COMPLETED,
    NotificationArea.PEOPLE,
    NotificationSubArea.COLLABORATION,
  ],
  [
    NotificationTopic.FORM_TEMPLATE_UPDATED,
    NotificationArea.ADMIN,
    NotificationSubArea.NONE,
  ],
];
